import { aludraApi } from 'Api/axios'
import { paymentConfigUrls } from './paymentConfig.urls'

export const getPublicKey = config =>
  aludraApi.get(paymentConfigUrls.publicKey, config)

export const getPaymentMethods = (companyId, config) =>
  aludraApi.get(paymentConfigUrls.paymentMethods(companyId), config)

export const getPaymentMethodFields = (paymentTypeId, config) =>
  aludraApi.get(paymentConfigUrls.paymentMethodFields(paymentTypeId), config)

export const getPaymentMethodConfig = (paymentTypeId, companyId, config) =>
  aludraApi.get(
    paymentConfigUrls.paymentMethodConfig(paymentTypeId, companyId),
    config
  )

export const savePaymentMethodConfig = (paymentTypeId, payload, config) =>
  aludraApi.post(
    paymentConfigUrls.savePaymentMethodConfig(paymentTypeId),
    payload,
    config
  )

export const updatePaymentMethodStatus = (paymentTypeId, payload, config) =>
  aludraApi.patch(
    paymentConfigUrls.updatePaymentMethodStatus(paymentTypeId),
    payload,
    config
  )
